{
  "title": "Cash",
  "common": {
    "deposit": "deposit",
    "close": "Close",
    "select": "Select"
  },
  "nonAgencyOnlySelected": {
    "header": "This section isn't available for the entities you're viewing",
    "body": "Use the entity selector to select at least one entity where you have deposits permission."
  },
  "status": {
    "inProgress": "In Progress",
    "scheduled": "Scheduled",
    "active": "Active",
    "closed": "Closed",
    "awaitingFunds": "Awaiting Funds",
    "transferSubmitted": "Transfer Submitted",
    "pending": "Pending",
    "unknown": "Unknown"
  },
  "pendingTable": {
    "header": "Pending deposits",
    "download": {
      "tooltip": "Download funding slip",
      "progressLabel": "Funding Slip download in progress",
      "successLabel": "Your PDF has been successfully downloaded",
      "errorLabel": "Unable to download Funding Slip. Please try again. If the problem persists, contact Client Services."
    }
  },
  "whatsThis": {
    "title": "What's this?",
    "modal": {
      "header": "Pending deposits",
      "description": "This table shows deposits that are not yet active. These deposits are not yet included in your total balance.",
      "awaitingFunds": {
        "header": "Awaiting Funds",
        "description": "These are deposits awaiting funds from you to complete the deposit."
      },
      "transferSubmitted": {
        "header": "Transfer Submitted",
        "description": "The automatic transfer to fund this deposit is being processed. You can view this Auto Deposit in the Payments section."
      },
      "pending": {
        "header": "Pending",
        "description": "These are funds that have been transferred and are waiting to be allocated to your deposit."
      }
    }
  },
  "table": {
    "header": "Deposits",
    "headers": {
      "name": "Detail",
      "status": "Status",
      "entity": "Entity",
      "investDate": "Invest date",
      "maturityDate": "Maturity",
      "requestDate": "Request date",
      "currency": "Currency",
      "currentBalance": "Current balance",
      "interestEarned": "Interest earned",
      "amount": "Amount",
      "action": "Action"
    },
    "emptyState": {
      "title": "Find added deposits here",
      "description": "Once you have added a deposit, come back here to view it."
    },
    "errorState": {
      "title": "Something went wrong while loading Deposits",
      "description": "Please try refreshing the table. If the problem persists, contact Client Services."
    }
  },
  "withdrawalsTable": {
    "header": "Pending withdrawals",
    "emptyState": {
      "title": "Find in progress withdrawals here",
      "description": "Once you have made a withdrawal from a deposit, come back here to view it."
    },
    "errorState": {
      "title": "Something went wrong while loading Withdrawals",
      "description": "Please try refreshing the table. If the problem persists, contact Client Services."
    },
    "columns": {
      "action": {
        "viewDeposit": "View deposit",
        "cancel": "Cancel"
      }
    }
  },
  "modals": {
    "cancelWithdraw": {
      "success": "Your scheduled withdrawal has been successfully cancelled.",
      "error": {
        "title": "Unable to cancel your withdrawal",
        "body": "Please try again. If the issue continues, please contact Client Services."
      },
      "actions": {
        "cancel": "No",
        "confirm": "Yes, cancel withdrawal"
      },
      "title": "Cancel scheduled withdrawal?",
      "subtitle": "Are you sure you want to cancel this scheduled withdrawal?",
      "alert": {
        "title": "Please note",
        "content": "Withdrawals cannot be cancelled within 24 hours of their scheduled request date."
      }
    }
  },
  "depositActivity": {
    "table": {
      "header": "Deposit activity",
      "headers": {
        "detail": "Detail",
        "amount": "Amount",
        "balance": "Balance",
        "action": "Action"
      },
      "errorState": {
        "title": "Something went wrong while loading the Deposit activity",
        "description": "Please try refreshing the page. If the problem persists, contact Client Services."
      }
    },
    "instructionTypes": {
      "creditInterest": "Interest paid",
      "withdrawal": "Withdrawal",
      "deposit": "Deposit",
      "interestPayout": "Interest payout",
      "earlyAccessFee": "Early Access Fee"
    },
    "download": {
      "progressLabel": "Interest Statement download in progress",
      "successLabel": "Your PDF has been successfully downloaded",
      "errorLabel": "Unable to download Interest Statement. Please try again. If the problem persists, contact Client Services."
    }
  },
  "depositSummary": {
    "title": "Summary",
    "headers": {
      "status": "Status",
      "depositId": "Deposit ID",
      "entity": "Entity",
      "product": "Product",
      "maturityDate": "Maturity date",
      "earliestMaturityDate": "Earliest maturity date",
      "netRate": "Net rate",
      "noticeEffectiveRate": "Notice effective rate",
      "depositAmount": "Deposit amount",
      "interestEarned": "Interest earned",
      "withdrawn": "Withdrawn"
    },
    "labels": {
      "deposits_one": "({{count}} deposit)",
      "deposits_other": "({{count}} deposits)",
      "withdrawals_one": "({{count}} withdrawal)",
      "withdrawals_other": "({{count}} withdrawals)",
      "errorLoading": "Unable to load deposit details. Please try again. If the problem persists, contact Client Services."
    }
  },
  "currentBalance": "Current balance",
  "avaliableBalance": "Available balance: {{balance}}",
  "tooltips": {
    "viewDeposit": "View deposit",
    "downloadInterestStatement": "Download Interest Statement",
    "contactClientServices": "Contact aatrades@alphagroup.com to download interest statement",
    "pendingStatus": "Funds that have been transferred and are waiting to be allocated to a deposit.",
    "awaitingFundsStatus": "Awaiting funds from you to complete the deposit.",
    "transferSubmittedStatus": "The transfer has been submitted and is being processed.",
    "pendingDeposits": "Pending deposits are not included in your total balance.",
    "interestEarned": "Interest earned since inception to end of last month."
  },
  "totalBalances": {
    "header": "Total balances",
    "interestEarned": "Interest earned",
    "pendingDeposits": "Pending deposits"
  },
  "newDeposit": {
    "title": "New deposit",
    "steps": {
      "depositDetails": {
        "title": "Deposit details",
        "description": "Choose a product and fill in the details. Following this we will present all applicable deposit banks and interest rates.",
        "productCard": {
          "title": "Product",
          "description": "Select the product where you want to place the deposit.",
          "productType": {
            "notice": {
              "title": "Notice",
              "description": "Requires advance notice of either 32 or 95 days before withdrawing funds."
            },
            "instantAccess": {
              "title": "Instant access",
              "description": "Offers daily access to cash."
            },
            "fixedTerm": {
              "title": "Term",
              "description": "Fix your interest rate for the duration of your chosen term, cannot be withdrawn until maturity."
            }
          }
        },
        "detailsCard": {
          "title": "Details",
          "description": "Enter the deposit details below before continuing.",
          "fields": {
            "entity": {
              "title": "Entity",
              "description": "Which of your entities is placing the deposit.",
              "placeholder": "Select entity"
            },
            "currencyCode": {
              "title": "Deposit currency"
            },
            "amount": {
              "title": "Deposit amount",
              "placeholder": "Enter amount",
              "validation": "{{label}} must be greater than or equal to 50,000"
            },
            "termLength": {
              "title": "Term length",
              "description": "Lorem ipsum dolor sit amet consectetur.",
              "placeholder": "Months",
              "validation": "Please enter a term of 2 months to 24 months. For longer terms, please contact us for a custom rate."
            },
            "interest": {
              "title": "Interest",
              "description": "Select how you would like the interest on the deposit to be paid",
              "options": {
                "monthly": {
                  "title": "Monthly",
                  "description": "Interest is paid out each month"
                },
                "compound": {
                  "title": "Compounding",
                  "description": "Interest paid is reinvested"
                }
              }
            },
            "notice": {
              "title": "Notice",
              "description": "When you request a withdrawal this is the number of days after which the money will be available.  ",
              "options": {
                "32days": {
                  "title": "32 days"
                },
                "95days": {
                  "title": "95 days"
                }
              }
            }
          }
        },
        "termDepositCard": {
          "title": "Term deposit",
          "description": "Please speak to one of our team to open a term deposit.",
          "info": "Term deposits cannot be quoted through our online portal. Contact us at <1>aatrades@alphagroup.com</1> for a personalised quote."
        }
      },
      "offeredRates": {
        "title": "Offered rates",
        "loading": "Loading your rates",
        "productType": {
          "instantAccess": {
            "title": "Instant Access Deposit",
            "description": "This Instant Access account provides same day access to cash (in accordance with cut-off times) meaning cash can be withdrawn at any point.",
            "option": "Instant access"
          },
          "notice32days": {
            "title": "32 Day Notice Deposit",
            "description": "This account has a 32 day notice period, which means cash is paid back 32 days after a withdrawal request is made.",
            "option": "32 day notice"
          },
          "notice95days": {
            "title": "95 Day Notice Deposit",
            "description": "This account has a 95 day notice period, which means cash is paid back 95 days after a withdrawal request is made.",
            "option": "95 day notice"
          },
          "fixedTerm": {
            "title": "Term Deposit",
            "description": "This is a Fixed Term account meaning the interest rate is fixed for the duration of your deposit. Cash cannot be withdrawn early.",
            "option": "Term"
          }
        },
        "pricingCard": {
          "offeredRate": "Offered rate",
          "projectedValue": "Projected value in one year",
          "gainsOf": "Including gains of"
        },
        "quotes": {
          "bankOfAmerica": {
            "instantAccessTerm": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the IORB rate set by the Federal Reserve and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-2 | Moody’s P-1 | Fitch F1+"
              }
            }
          },
          "barclays": {
            "instantAccessTerm": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1"
              }
            },
            "notice32": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1",
                "salesPoint2": "A 0.15% rate reduction will be incurred upon giving notice"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1",
                "salesPoint2": "A 0.15% rate reduction will be incurred upon giving notice"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1",
                "salesPoint2": "A 0.15% rate reduction will be incurred upon giving notice"
              }
            },
            "notice95": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1",
                "salesPoint2": "A 0.2% rate reduction will be incurred upon giving notice"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1",
                "salesPoint2": "A 0.2% rate reduction will be incurred upon giving notice"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1",
                "salesPoint2": "A 0.2% rate reduction will be incurred upon giving notice"
              }
            }
          },
          "lloyds": {
            "instantAccessTerm": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+"
              }
            },
            "notice32": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+",
                "salesPoint2": "No post rate reduction"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+",
                "salesPoint2": "No post rate reduction"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+",
                "salesPoint2": "No post rate reduction"
              }
            },
            "notice95": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+",
                "salesPoint2": "No post rate reduction"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+",
                "salesPoint2": "No post rate reduction"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-1 | Moody’s P-1 | Fitch F1+",
                "salesPoint2": "No post rate reduction"
              }
            }
          },
          "goldmanSachs": {
            "instantAccessTerm": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Effective Federal Fund Rate (EFFR) and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-2 | Moody’s P-1 | Fitch F1"
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Sterling Overnight Index Average (SONIA) and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-2 | Moody’s P-1 | Fitch F1"
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the Euro Short Term Rate (ESTR) base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P A-2 | Moody’s P-1 | Fitch F1"
              }
            }
          },
          "bankingCircle": {
            "subtitle": "Deposited with Central Bank of Luxembourg",
            "instantAccessTerm": {
              "USD": {
                "rateDisclaimer": "The rate we offer is linked to the Federal Funds Target Range and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P AAA | Moody’s Aaa | Fitch AAA",
                "salesPoint2": "Cash is held with Central Bank of Luxembourg, credit rating above."
              },
              "GBP": {
                "rateDisclaimer": "The rate we offer is linked to the Bank of England base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P AAA | Moody’s Aaa | Fitch AAA",
                "salesPoint2": "Cash is held with Central Bank of Luxembourg, credit rating above."
              },
              "EUR": {
                "rateDisclaimer": "The rate we offer is linked to the European Central Bank base rate and may vary as that rate changes.",
                "salesPoint1": "Credit ratings: S&P AAA | Moody’s Aaa | Fitch AAA",
                "salesPoint2": "Cash is held with Central Bank of Luxembourg, credit rating above."
              }
            }
          },
          "errorState": {
            "title": "Something went wrong while loading Quotes",
            "description": "Please try again. If the problem persists, contact Client Services."
          }
        }
      },
      "review": {
        "title": "Review",
        "description": "Check the details of the deposit below before opening and funding your deposit.",
        "openDeposit": "Open deposit",
        "summaryCard": {
          "title": "Summary",
          "fields": {
            "entity": "Entity",
            "product": "Product",
            "currency": "Currency",
            "earliestMaturity": "Earliest maturity",
            "rate": "Rate",
            "noticeRate": "Notice effective rate",
            "depositAmount": "Deposit amount"
          },
          "warning": {
            "title": "Important information",
            "description": {
              "notice32days": "This deposit has a 32 day notice period. When you request a withdrawal, your money will be available after 32 days.",
              "notice95days": "This deposit has a 95 day notice period. When you request a withdrawal, your money will be available after 95 days."
            }
          }
        },
        "confirm": "I confirm the deposit details above are correct.",
        "confirmRequired": "Need to confirm deposit details",
        "error": {
          "openDeposit": {
            "title": "Unable to Open Deposit"
          }
        }
      },
      "fundDeposit": {
        "title": "Fund deposit",
        "description": "Your deposit has been successfully created. To complete it, please transfer the funds using the details below.",
        "alert": {
          "notFunded": {
            "title": "Deposit not yet funded",
            "description": "You have 48 hours to fund the deposit. After that, it will be closed and you’ll need to request a new quote. To fund it later, go to the 'Pending deposits' section on the Cash page."
          },
          "downloadSlip": {
            "title": "Please note",
            "description": {
              "withAutomaticTransferEnabled": "For manually funded deposits, you can also download the funding slip from Pending Deposits."
            }
          }
        },
        "cutOffTimeTooltip": "Fund by this time for same-day processing; funds received after this may not be processed today.",
        "cards": {
          "download": {
            "title": "Download"
          },
          "fundingDetails": {
            "title": "Funding details",
            "fundingMethod": {
              "title": "How would you like to fund this deposit?",
              "description": "Choose between an Automatic Transfer or Manual Transfer",
              "options": {
                "automatic": { "title": "Automatic Transfer", "description": "Transfer automatically from an account" },
                "manual": { "title": "Manual Transfer", "description": "Get bank details for a manual transfer" }
              }
            },
            "automaticTransferUnavailable": {
              "title": "Enable Automatic Transfers",
              "description": "Once enabled, choose an Alpha account directly from this page to fund your deposit seamlessly",
              "pleaseEmail": "Please email Client Services to enable Automatic Transfers.",
              "alert": {
                "content": "Automatic transfers aren't enabled for the selected entity. You can continue by using manual transfer, or contact <1>aatrades@alphagroup.com</1> to enable automatic transfers."
              }
            },
            "fundingAccount": {
              "label": "Which account would you like to use to fund the deposit?",
              "subLabel": "The accounts can only be associated to the deposit entity you have selected",
              "placeholder": "Select account",
              "insufficientFunds": "Insufficient Funds"
            },
            "balanceImpact": {
              "header": "Balance impact",
              "fields": {
                "availableBalance": "Available balance before transfer",
                "depositAmount": "Deposit amount",
                "remainingBalance": "Available balance after transfer"
              }
            },
            "bankTransferDetails": {
              "title": "Bank transfer details",
              "description": "Use these details to transfer funds to fund the deposit",
              "items": {
                "generated": "Generated",
                "cutOff": "Cut-off time",
                "amountDue": "Amount due",
                "accountName": "Account name",
                "iban": "IBAN",
                "swift": "SWIFT / BIC",
                "paymentReference": "Payment reference"
              },
              "errorState": {
                "title": "Unable to Retrieve Bank Transfer Details",
                "description": "Your deposit was opened successfully, but we couldn’t retrieve the bank transfer details. Please check your funding slip."
              }
            }
          }
        },
        "buttons": {
          "downloadSlip": "Download funding slip",
          "emailAndClose": "Email funding slip & close",
          "transferFunds": "Transfer Funds",
          "close": "Close"
        },
        "manualTransfer": {
          "sendConfirmationEmail": {
            "success": {
              "title": "Funding Slip Sent",
              "body": "Your funding slip has been emailed. Use these details to transfer funds to your deposit."
            },
            "error": {
              "title": "Email Not Sent",
              "body": "We couldn’t send the funding slip. Download it from the Deposits Cash page to complete your transfer."
            }
          }
        },
        "automaticTransfer": {
          "error": {
            "title": "Automatic Transfer Failed",
            "body": "Please try again or use manual transfer to fund the deposit."
          },
          "success": {
            "title": "Automatic Transfer submitted",
            "body": "Your Automatic Transfer has been submitted successfully."
          }
        },
        "howAutomaticTransferWorks": {
          "title": "How do automatic transfers work?",
          "content": {
            "line1": "A transfer will be automatically created from your selected funding account.",
            "line2": "If you submit after cut-off time, the transfer will be processed on the next banking day, just like a standard transfer.",
            "line3": "Until the transfer is processed, your newly created deposit will have the status Transfer Submitted."
          }
        }
      }
    }
  },
  "withdraw": {
    "title": "Withdraw funds",
    "buttons": {
      "withdrawNotice": "Submit withdraw notice",
      "withdraw": "Submit withdraw",
      "withdrawal": "Submit withdrawal"
    },
    "cards": {
      "depositDetails": {
        "header": "Deposit details",
        "fields": {
          "product": "Product",
          "depositId": "Deposit ID",
          "entity": "Entity",
          "currentBalance": "Current balance",
          "availableBalance": "Available balance",
          "earliestMaturityDate": "Earliest maturity date",
          "maturityDate": "Maturity date",
          "requestDate": "Withdrawal request date"
        },
        "tooltips": {
          "maturityDate": "This is the expected date you will receive the funds.",
          "requestDate": "This is the date the withdrawal request will be placed."
        }
      }
    },
    "steps": {
      "depositDetails": {
        "title": "Withdrawal details",
        "description": "Please review the details below and enter the amount you would like to withdraw.",
        "errors": {
          "bankTransferDetails": {
            "title": "Unable to load “Withdraw to” bank details.",
            "content": "Please try again. If the issue continues, please contact Client Services."
          },
          "submitWithdrawal": {
            "title": "Unable to submit withdrawal"
          }
        },
        "cards": {
          "withdrawFrom": {
            "title": "Withdraw from",
            "description": "Please select the entity and deposit you want to withdraw from.",
            "warning": {
              "title": "Important information",
              "description": {
                "notice32days": "This deposit has a 32 day notice period. When you request a withdrawal, your money will be available after 32 days.",
                "notice95days": "This deposit has a 95 day notice period. When you request a withdrawal, your money will be available after 95 days."
              }
            },
            "fields": {
              "deposit": {
                "title": "Deposit",
                "placeholder": "Select deposit"
              }
            }
          },
          "withdrawDetails": {
            "title": "Withdrawal details",
            "description": "Specify the amount and timing of the withdrawal.",
            "fields": {
              "withdrawalDate": {
                "title": "Date to place withdrawal request"
              },
              "amount": {
                "title": "Withdraw amount",
                "description": "Current balance {{balance}}",
                "exceedBalanceError": "Withdraw amount can't exceed available balance.",
                "minimumError": "Withdraw amount needs to be bigger than 0."
              }
            },
            "alert": {
              "title": "Please note",
              "content": {
                "line1": "Your withdrawal request is placed on this date. If your deposit requires notice (e.g. 32 days), the maturity will be that many days later.",
                "line2": "Withdrawal request dates on weekends or national holidays are actioned the next banking day."
              }
            }
          },
          "withdrawTo": {
            "title": "Withdraw To",
            "description": "Withdrawn funds will be sent to the following bank details.",
            "items": {
              "accountName": "Account name",
              "accountNumber": "Account number",
              "sortCode": "Sort code",
              "iban": "IBAN",
              "swift": "SWIFT / BIC",
              "paymentReference": "Payment reference"
            },
            "alert": {
              "title": "Please note",
              "content": "Withdrawals will only be sent to the same bank account that was used to make the initial deposits."
            }
          },
          "confirmation": {
            "understandNotice": "I understand that the notice effective rate will apply to any withdrawals from this deposit",
            "detailsCorrect": "I confirm the withdrawal details above are correct"
          }
        }
      },
      "confirmation": {
        "title": "Confirmation",
        "description": "Please see below confirmation of the submitted withdrawal.",
        "buttons": {
          "close": "Close"
        },
        "alert": {
          "withdrawSuccess": {
            "title": "Withdrawal successfully submitted",
            "content": "You can view the in progress withdrawal in the ‘Withdrawals’ tab on the Cash page."
          }
        },
        "toast": {
          "failedToLoadDetails": {
            "title": "Some confirmation details couldn’t be displayed",
            "body": "Your withdrawal was still submitted successfully. Check the Withdrawals tab for the latest status."
          }
        },
        "cards": {
          "summary": {
            "header": "Summary",
            "description": "Please see the details of the withdrawal below.",
            "summaryTiles": {
              "withdrawAmount": "Withdraw amount",
              "maturityDate": "Maturity date",
              "reference": "Reference"
            }
          },
          "balanceImpact": {
            "header": "Balance impact",
            "fields": {
              "availableBalance": "Available balance before withdrawal",
              "withdrawalAmount": "Withdrawal amount",
              "remainingBalance": "Available balance after withdrawal"
            }
          }
        }
      }
    }
  }
}
